import {CommonNs, CompanyNs, type DropdownNs} from '@shared/types';
import {
  companySizeOptions,
  organizationOptions,
  selectableProperties,
  visibilityOptions,
} from '@shared/constants/selectable-properties.constants';
import {customPropertyDropdownOptions} from "@shared/constants";

const companyProperties = [
  ...selectableProperties,
  {
    label: 'Company Name',
    icon: 'Building',
    iconType: 'fal',
    isFixed: true,
    input: {
      name: CompanyNs.PropertyEnums.COMPANY,
      type: 'text',
      placeholder: 'Company Name',
      value: '',
    },
    dropdown: {
      name: 'companyPermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
  {
    label: 'Company Email',
    icon: 'Mail',
    iconType: 'fal',
    isFixed: true,
    input: {
      name: CompanyNs.PropertyEnums.COMPANY_EMAIL,
      type: 'text',
      placeholder: 'Company Email',
      value: '',
    },
    dropdown: {
      name: 'companyEmailPermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
  {
    label: 'Organization',
    icon: 'Workflow',
    iconType: 'fal',
    isFixed: true,
    input: {
      name: CompanyNs.PropertyEnums.ORGANIZATION,
      type: 'select',
      placeholder: 'Organization',
      value: '',
      selectOptions: organizationOptions,
    },
    dropdown: {
      name: 'organizationPermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
  {
    label: 'Company Size',
    icon: 'Users',
    iconType: 'fal',
    isFixed: true,
    input: {
      name: CompanyNs.PropertyEnums.COMPANY_SIZE,
      type: 'select',
      placeholder: 'Company Size',
      value: '',
      selectOptions: companySizeOptions,
    },
    dropdown: {
      name: 'companySizePermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
  {
    label: 'Industry',
    icon: 'Factory',
    iconType: 'fal',
    input: {
      name: CompanyNs.PropertyEnums.INDUSTRY,
      type: 'select',
      placeholder: 'Industry',
      value: '',
      selectOptions: visibilityOptions,
    },
    dropdown: {
      name: 'industryPermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
  {
    label: 'Tech Stack',
    icon: 'Layers',
    iconType: 'fal',
    input: {
      name: CompanyNs.PropertyEnums.TECH_STACK,
      type: 'multiselect',
      placeholder: 'Tech Stack',
      value: '',
      selectOptions: visibilityOptions,
    },
    dropdown: {
      name: 'tachStackPermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
  {
    label: 'Legal Notice',
    icon: 'Scale',
    iconType: 'fal',
    input: {
      name: CompanyNs.PropertyEnums.LEGAL,
      type: 'text',
      placeholder: 'Legal Notice',
      value: '',
    },
    dropdown: {
      name: 'legalNoticePermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
  {
    label: 'Founded',
    icon: 'Scale',
    iconType: 'fal',
    input: {
      name: CompanyNs.PropertyEnums.FOUNDED,
      type: 'text',
      placeholder: 'Founded',
      value: '',
    },
    dropdown: {
      name: 'foundedPermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
  {
    label: 'Description',
    icon: 'Scale',
    iconType: 'fal',
    input: {
      name: CompanyNs.PropertyEnums.DESCRIPTION,
      type: 'textarea',
      placeholder: '',
      value: '',
    },
    dropdown: {
      name: 'descriptionPermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
  {
    label: 'Project Size',
    icon: 'ChevronsUpDown',
    iconType: 'fal',
    input: {
      name: CompanyNs.PropertyEnums.PROJECT_SIZE,
      type: 'select',
      placeholder: 'Project Size',
      value: '',
      selectOptions: visibilityOptions,
    },
    dropdown: {
      name: 'projectSizePermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
  {
    label: 'Product Hunt',
    icon: 'product-hunt',
    iconType: 'fal',
    input: {
      name: CompanyNs.PropertyEnums.PRODUCT_HUNT,
      type: 'text',
      placeholder: 'Product Hunt',
      value: '',
    },
    dropdown: {
      name: 'productHuntPermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
  {
    label: 'Clutch.co',
    icon: 'logos/clutch-co.svg',
    iconType: 'fal',
    input: {
      name: CompanyNs.PropertyEnums.CLUTCH_CO,
      type: 'text',
      placeholder: 'Clutch.co',
      value: '',
    },
    dropdown: {
      name: 'clutchCoPermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
  {
    label: 'Angel.co',
    icon: 'angellist',
    iconType: 'fal',
    input: {
      name: CompanyNs.PropertyEnums.ANGEL_CO,
      type: 'text',
      placeholder: 'Angel.co',
      value: '',
    },
    dropdown: {
      name: 'angelCoPermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
  {
    label: 'Crunchbase',
    icon: 'logos/crunchbase.svg',
    iconType: 'fal',
    input: {
      name: CompanyNs.PropertyEnums.CRUNCH_BASE,
      type: 'text',
      placeholder: 'Crunchbase',
      value: '',
    },
    dropdown: {
      name: 'crunchBasePermission',
      options: visibilityOptions,
      value: CommonNs.PermissionsEnums.EVERYONE,
    },
  },
] as CommonNs.InputFormGroup[];

export const companyDropdownProperties = [
  {
    name: 'Company',
    iconType: 'fal',
    icon: 'Building',
    subOptions: {
      title: 'COMPANY',
      options: [
        {
          name: 'Industry',
          iconType: 'far',
          icon: 'Factory',
          value: CompanyNs.PropertyEnums.INDUSTRY,
        },
        {
          name: 'Tech Stack',
          iconType: 'fal',
          icon: 'Layers',
          value: CompanyNs.PropertyEnums.TECH_STACK,
        },
        {
          name: 'Legal Notice',
          iconType: 'fal',
          icon: 'Scale',
          value: CompanyNs.PropertyEnums.LEGAL,
        },
        {
          name: 'Founded',
          iconType: 'fal',
          icon: 'Heart',
          value: CompanyNs.PropertyEnums.FOUNDED,
        },
        {
          name: 'Language',
          inputName: 'founded',
          inputType: 'multiselect',
          iconType: 'fal',
          icon: 'Globe',
          value: 'language',
        },
        {
          name: 'Description',
          iconType: 'fal',
          icon: 'AlignLeft',
          value: CompanyNs.PropertyEnums.DESCRIPTION,
        },
        {
          name: 'Project Size',
          iconType: 'fal',
          icon: 'ChevronsUpDown',
          value: CompanyNs.PropertyEnums.PROJECT_SIZE,
        },
        {
          name: 'Hourly Rate',
          iconType: 'fal',
          icon: 'Clock',
          value: 'hourly_rate',
        },
        {
          name: 'Daily Rate',
          iconType: 'fal',
          icon: 'Calendar',
          value: 'daily_rate',
        },
      ],
    },
  },
  {
    name: 'Location',
    iconType: 'fal',
    icon: 'MapPin',
    subOptions: {
      title: 'LOCATION',
      options: [
        {
          name: 'City',
          iconType: 'fal',
          icon: 'MapPin',
          value: 'city',
        },
        {
          name: 'Country',
          iconType: 'fal',
          icon: 'Globe',
          value: 'country',
        },
      ],
    },
  },
  {
    name: 'Contact',
    iconType: 'fal',
    icon: 'Contact',
    subOptions: {
      title: 'CONTACT',
      options: [
        {
          name: 'Phone',
          iconType: 'fal',
          icon: 'Phone',
          value: 'phone',
        },
        {
          name: 'Mobile',
          iconType: 'fal',
          icon: 'Smartphone',
          value: 'mobile',
        },
        {
          name: 'Email',
          iconType: 'fal',
          icon: 'AtSign',
          value: 'email',
        },
        {
          name: 'Website',
          iconType: 'fal',
          icon: 'Link',
          value: 'website',
        },
      ],
    },
  },
  {
    name: 'Social Media',
    iconType: 'fal',
    icon: 'Share2',
    subOptions: {
      title: 'SOCIAL MEDIA',
      options: [
        {
          name: 'Linkedin',
          iconType: 'fab',
          icon: 'linkedin',
          value: 'linkedin',
        },
        {
          name: 'Facebook',
          iconType: 'fab',
          icon: 'facebook',
          value: 'facebook',
        },
        {
          name: 'Instagram',
          iconType: 'fab',
          icon: 'instagram',
          value: 'instagram',
        },
        {
          name: 'Twitter',
          iconType: 'fab',
          icon: 'twitter',
          value: 'twitter',
        },
        {
          name: 'Youtube',
          iconType: 'fab',
          icon: 'youtube',
          value: 'youtube',
        },
        {
          name: 'Whatsapp',
          iconType: 'fab',
          icon: 'whatsapp',
          value: 'whatsapp',
        },
        {
          name: 'Telegram',
          iconType: 'fab',
          icon: 'telegram',
          value: 'telegram',
        },
      ],
    },
  },
  {
    name: 'Review',
    icon: 'Star',
    iconType: 'fal',
    subOptions: {
      title: 'Review',
      options: [
        {
          name: 'Product Hunt',
          iconType: 'fab',
          icon: 'product-hunt',
          value: 'productHunt',
        },
        {
          name: 'Clutch.co',
          svg: 'logos/clutch-co.svg',
          value: 'clutchCo',
        },
        {
          name: 'Angel.co',
          iconType: 'fab',
          icon: 'angellist',
          value: 'angelCo',
        },
        {
          name: 'Crunchbase',
          svg: 'logos/crunchbase.svg',
          value: 'crunchBase',
        },
      ],
    },
  },
  {
    hasDivider: true,
  },
  ...customPropertyDropdownOptions,
] as DropdownNs.DropdownOptionsItem[];

export default companyProperties;
